const items = {
  "setting.display.original.label": "original",
  "setting.display.original.description": "original(read mode)",
  "setting.layout.direction.label": "direction",
  "setting.layout.direction.description": "横向或者纵向排版",
  "setting.layout.direction.col.label": "colum",
  "setting.layout.direction.row.label": "row",
  "setting.layout.paragraph.label": "对照方式",
  "setting.layout.paragraph.description": "逐段或逐句对照（仅阅读模式）",
  "setting.layout.paragraph.paragraph.label": "逐段",
  "setting.layout.paragraph.sentence.label": "逐句",
  "setting.pali.script.primary.label": "pali script",
  "setting.pali.script.primary.description": "primary",
  "setting.pali.script.secondary.label": "pali script",
  "setting.pali.script.secondary.description": "secondary",
  "setting.pali.script.rome.label": "rome",
  "setting.pali.script.my.label": "myanmar",
  "setting.pali.script.si.label": "sinhala",
  "setting.pali.script.thai.label": "thai",
  "setting.pali.script.tai.label": "傣仂文字母",
  "setting.pali.script.none.label": "none",
  "setting.search.match.label": "match",
  "setting.search.match.complete.label": "complete",
  "setting.search.match.case.label": "declension",
  "setting.search.match.similar.label": "similar",
  "setting.search.orderby.label": "order by",
  "setting.search.orderby.rank.label": "rank",
  "setting.search.orderby.paragraph.label": "paragraph",
  "setting.dict.lang.label": "language",
  "setting.dict.lang.description": "字典查询结果的语言排序",
  "setting.nissaya.layout.read.label": "layout(read)",
  "setting.nissaya.layout.edit.label": "layout(edit)",
  "setting.nissaya.layout.inline.label": "inline",
  "setting.nissaya.layout.list.label": "list",
  "setting.wbw.order.label": "wbw input order",
  "setting.term.first.show.label": "First Term",
  "setting.term.first.show.description": "Show First Term",
  "term.first.show.meaning_pali_others": "Meaning & Pali & Others Meaning",
  "term.first.show.meaning_pali": "Meaning & Pali",
  "term.first.show.meaning_others": "Meaning & Others Meaning",
  "term.first.show.meaning": "Meaning Only",
  "setting.layout.commentary.label": "Commentary Layout",
  "setting.layout.root.fixed.label": "Root Text Fixed",
};

export default items;
